<template>
  <generic-modal :modal-key="'daily-bonus-game-reward'"
                 :classStyle="'bonus_phase_box claim_prize_box modal_cont'"
                 :idProp="'games-reward'"
                 @close="closeModal">
    <template slot="content">
      <h1>{{ getTranslations.home_bonus_header }}<br> {{ getTranslations.home_bonus_you_won }}</h1>
      <img src="static/images/daily_bonus/photo-ClaimPrize.png" class="bonus_img">

      <div class="claim_prize_section">
        <img :src="openCorrectImg()" class="claim_prize_img">
      </div>
      <p>{{ getTranslations.home_bonus_you_won }} {{ bonusDailyModal.quantity }} {{ getTranslations.home_bonus_games }}</p>
      <button type="button" @click="closeModal">{{ getTranslations.home_bonus_claim_prize }}</button>
    </template>
  </generic-modal>
</template>

<script>
// bonus_claim_prize_popup.html
import { mapGetters, mapMutations, mapState } from 'vuex';
import { chevronDownloop } from '@/common/jQuery';
import GenericModal from '../../../sharedcomponents/GenericModal';

export default {
  name: 'daily-bonus-game-reward',
  components: { GenericModal },
  mounted() {
    this.$nextTick(() => {
      chevronDownloop();
    });
  },
  methods: {
    ...mapMutations('common', [
      'storeModalForHomePage',
    ]),
    ...mapMutations('profile', [
      'saveBonusDailyModal',
    ]),
    openCorrectImg() {
    // eslint-disable-next-line
    return `static/images/daily_bonus/icon-daily_bonus-day${this.bonusDailyModal.loginStreak}-points-tag.svg`;
    },
    closeModal() {
      this.storeModalForHomePage(null);
      this.saveBonusDailyModal(null);
      this.$emit('close');
    },
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapState('profile', [
      'bonusDailyModal',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/bonus_phases/daily_bonus_modals/GameBonus.vue